export default "__VITE_ASSET__KImA7i2c__"